import { Button, Card, CardBody, Col, CustomInput, Input, Row } from 'reactstrap';
import Select from 'react-select';
import {
  VISIT_STATUS,
  VISIT_STATUS_NAMES,
  VisitPreSaleState,
  VISIT_PRE_SALE_STATUS_NAMES,
} from '../../../constants/visitsConstants';
import useSdrList from '../../../hooks/useSdrList';
import { Option } from '../../../models/formModel';
import { activeTab } from '../types/dashboard.types';

interface DashboardFilterBarProps {
  activeTab: activeTab;
  isRestricted: boolean;
  startDate: string;
  endDate: string;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  status: string;
  onStatusChange: (status: string) => void;
  showOnlyAssigned?: boolean;
  onShowOnlyAssignedChange?: (checked: boolean) => void;
  selectedSdrId?: string;
  onSdrChange?: (sdrId: string) => void;
  onClearFilters: () => void;
  hideAssignmentControl?: boolean;
}

const TAB_SDR_ROLE: Record<
  activeTab,
  'SDR_RENT' | 'SDR_SALES' | 'SDR_PRESALES'
> = {
  rent: 'SDR_RENT',
  secondary: 'SDR_SALES',
  'pre-sale': 'SDR_PRESALES',
};

const getStatusOptions = (tab: activeTab): Option[] => {
  if (tab === 'pre-sale') {
    return Object.values(VisitPreSaleState).map((value) => ({
      value,
      label: VISIT_PRE_SALE_STATUS_NAMES[value],
    }));
  }
  return Object.values(VISIT_STATUS).map((value) => ({
    value,
    label: VISIT_STATUS_NAMES[value],
  }));
};

const DashboardFilterBar = ({
  activeTab: tab,
  isRestricted,
  startDate,
  endDate,
  onDateRangeChange,
  status,
  onStatusChange,
  showOnlyAssigned,
  onShowOnlyAssignedChange,
  selectedSdrId,
  onSdrChange,
  onClearFilters,
  hideAssignmentControl,
}: DashboardFilterBarProps) => {
  const { sdrOptions, isLoadingSdrs } = useSdrList(TAB_SDR_ROLE[tab]);
  const statusOptions = getStatusOptions(tab);

  return (
    <Card className="mb-4">
      <CardBody>
        <Row>
          <Col md={3}>
            <label className="form-control-label">Fecha inicio</label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => onDateRangeChange(e.target.value, endDate)}
            />
          </Col>
          <Col md={3}>
            <label className="form-control-label">Fecha fin</label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => onDateRangeChange(startDate, e.target.value)}
            />
          </Col>
          <Col md={3}>
            <label className="form-control-label">Estado</label>
            <Select
              options={statusOptions}
              isClearable
              placeholder="Todos"
              value={statusOptions.find((o) => o.value === status) ?? null}
              onChange={(option) => onStatusChange(option?.value ?? '')}
            />
          </Col>
          {!hideAssignmentControl && (
            <Col md={3}>
              {isRestricted ? (
                <>
                  <label className="form-control-label d-block">&nbsp;</label>
                  <CustomInput
                    type="checkbox"
                    id="showOnlyAssignedCheckbox"
                    label="Ver lo asignado"
                    checked={showOnlyAssigned}
                    onChange={(e) =>
                      onShowOnlyAssignedChange?.(e.target.checked)
                    }
                  />
                </>
              ) : (
                <>
                  <label className="form-control-label">SDR</label>
                  <Select
                    options={sdrOptions}
                    isClearable
                    isLoading={isLoadingSdrs}
                    placeholder="Todos"
                    value={
                      sdrOptions.find((o) => o.value === selectedSdrId) ?? null
                    }
                    onChange={(option) => onSdrChange?.(option?.value ?? '')}
                  />
                </>
              )}
            </Col>
          )}
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <Button color="secondary" outline onClick={onClearFilters}>
              Limpiar filtros
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default DashboardFilterBar;
